module.exports = Immutable;


//////////////////
// WEBPACK FOOTER
// external "Immutable"
// module id = 25
// module chunks = 0 1